module.exports = "# Ian and Sara Intro\n\nYouTube: HkQdJ2N1NN4\n\n## Notes\nIntro to the first installment of Esmeralda and Goober's planet protecting adventures (1:38).\n\n### Problems with your video buffering?\nPause the video and wait a minute for it to pre-load, then it should play without a hitch!\n\n# Esmeralda and Goober Opening Story\n\nYouTube: FIrtO7bBqlo\n\n## Notes\nEsmeralda and Goober welcome the Apprentices to the Academy (3:22).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/sections/12_esOpeningStory/level1_opening.md
// module id = 1835
// module chunks = 2